<!-- For Tutorials, removing copyable snippets -->
<script lang="ts">
  import CodeSample, { languages } from "$lib/ui/system/CodeSample.svelte";

  export let code: string;
  export let lang: string;

  $: source = decodeURIComponent(code);

  let sanitizedLang: keyof typeof languages | undefined;
  $: {
    if (lang in languages) {
      sanitizedLang = lang as any;
    } else {
      sanitizedLang = undefined;
      console.warn(`unknown language: ${lang}`);
    }
  }
</script>

<div class="my-6 not-prose">
  <CodeSample {source} lang={sanitizedLang} copyable={false} />
</div>
